import React from 'react';

// Material
import Drawer from '@material-ui/core/Drawer';

// Components
import StopNavigation from './StopNavigation';

// Styles
import useStyle from './styles';

interface StateProps {
  toggleDrawer(open: boolean, stopId?: string): (event: any) => void;
  id: string;
  open: boolean;
}

type Props = StateProps;

const InfoDrawer: React.FC<Props> = ({ id, open, toggleDrawer }) => {
  const classes = useStyle();

  return (
    <Drawer anchor='right' onClose={toggleDrawer(false)} open={open}>
      <div className={classes.drawerContents}>
        <StopNavigation stopId={id} />
      </div>
    </Drawer>
  );
};

export { InfoDrawer };
export default InfoDrawer;
